// extracted by mini-css-extract-plugin
export default {"DetailOverview":"Update_DetailOverview__1Pu2h","Detail":"Update_Detail__278+6"};